import React from 'react';
import './quicklink.css'

const Quicklinks = (props) => {
    return ( <>
    <h6 className='quicklinks'>{props.qlink}</h6>
    </> );
}
 
export default Quicklinks;